<template lang="pug">
  .order-details.xs-12(v-if="order")
    FixedWidthTweakUpper
      .section
        .xs-12
          BackButton(url="/dashboard/purchases/orders")

        .order-status-wrap.xs-12
          p.order-id.upper.color-slate.xs-f-xsmall.lg-f-small.max-at-tweak(data-mr-ass="order-id") order # {{order.invoice.id}}
          p.total.color-slate.xs-f-xsmall.lg-f-small.max-at-tweak.xs-text-right(data-mr-ass="order-total") {{this.order.invoice.total | currency}}
          p.order-placed.color-slate.xs-f-small.max-at-tweak(data-mr-ass="order-placed") Placed on {{order.invoice.paid_at || order.invoice.created_at | moment("MMMM&nbsp;Do&nbsp;YYYY")}}
          p.order-status.capitalize.semi-bold.xs-f-medium.lg-f-xmedium.max-at-tweak(data-mr-ass="order-status") {{order.invoice.order_status}}
          a.xs-f-small.max-at-tweak(v-if="order.invoice.order_status == 'shipped' && order.invoice.tracking_url" :href="order.invoice.tracking_url" data-mr-ass="tracking-url") Track&nbsp;
            span.icon-caret-right

        .order-items
          .xs-12(v-for="item in order.invoice.items" :key="item.id")
            OrderItem(v-if="item.visible" :item="item" :invoice-status="order.invoice.order_status").row

      .section
        .shipping-address.xs-12.md-4(v-if="order.shippingAddress.street_1")
          .xs-12.text-center
            p.bold.upper.xs-f-medium.max-at-tweak Shipping Address

          .detail-wrap.xs-12
            Address(:address="order.shippingAddress")

        .payment-method.xs-12.md-4
          .xs-12.text-center
            p.bold.upper.xs-f-medium.max-at-tweak(data-mr-ass="payment-method") Payment Method
              span(v-if="order.paymentMethods.length > 1") s

          .detail-wrap.xs-12
            template(v-if="order.paymentMethods.length")
              template(v-for="method in order.paymentMethods")
                .method-icon
                  span.xs-f-xxxlarge.max-at-tweak(:class="paymentProfileClass(method.paymentGateway, method.ccType)")
                .method(v-if="method.paymentGateway == 'amazon'")
                  p.xs-f-small.max-at-tweak Paid through&nbsp;
                    span.amazon-logo
                    | &nbsp;Amazon.com
                .method(v-else-if="method.paymentGateway == 'paypal'")
                  p.xs-f-small.max-at-tweak Paid through&nbsp;PayPal
                .method(v-else-if="method.paymentGateway == 'Giftcard'")
                  p.xs-f-small.max-at-tweak Giftcard ({{method.ccNum | currency}} remaining)
                .method(v-else-if="method.paymentGateway == 'braintree'")
                  p.xs-f-small.max-at-tweak(data-mr-ass="current-payment-method") {{method.ccType}} **** {{method.ccNum}}
                  p.xs-f-small.max-at-tweak Exp {{method.goodThru | moment("MM/YY")}}
                .method(v-else)
                  p.xs-f-small.max-at-tweak {{method.displayName}}

            template(v-else)
              p.xs-f-small.max-at-tweak No payment method on file

        .order-summary.xs-12.md-4
          .xs-12.text-center.xs-hide.sm-hide
            p.bold.upper.xs-f-medium.max-at-tweak Order Summary

          .detail-wrap.xs-12.xs-text-right.md-text-left
            .summary-wrap.text-left
              p.xs-f-small.max-at-tweak
                span.label Subtotal:&nbsp;
                span.price {{order.invoice.subTotal | currency}}

              p.xs-f-small.max-at-tweak(v-if="order.shippingMethod")
                span.label Shipping:&nbsp;
                span.price {{order.shippingMethod.displayPrice | freeCurrency}}

              template(v-if="order.promos.length")
                p.xs-f-small.max-at-tweak
                  span.label Promotions:&nbsp;
                  span.filler

                ul.promos
                  li.upper.color-slate.xs-f-small.max-at-tweak(v-for="promo in order.promos")
                    span.label {{promo.displayName}}&nbsp;
                    span.price(v-if="promo.amount && promo.offerType != 'freeShipping'") {{promo.amount | currency}}

              p.xs-f-small.max-at-tweak
                span.label
                  span(v-if="order.isPreOrder") Estimated&nbsp;
                  | Tax:&nbsp;
                span.price {{order.invoice.tax | currency}}

              p.xs-f-small.max-at-tweak(v-if="order.invoice.credits < 0")
                span.label Credits Applied:&nbsp;
                span.price {{order.invoice.credits | currency}}

              p.xs-f-small.max-at-tweak(v-if="order.invoice.tip_amount > 0")
                span.label Tip:&nbsp;
                span.price {{order.invoice.tip_amount | currency}}

              p.xs-f-small.max-at-tweak(v-if="order.invoice.capture_amount - order.invoice.auth_amount < 0")
                span.label Adjustment:&nbsp;
                span.price {{order.invoice.capture_amount - order.invoice.auth_amount | currency}}

              p.semi-bold.xs-f-small.max-at-tweak
                span.label Total:&nbsp;
                span.price {{order.invoice.total | currency}}

      SectionLink(url="/dashboard/purchases/orders" link-text="View All Purchases" caret-position="left")

      ExpertiseIncluded

</template>

<script>
  import vueCustomerSvc from '../../../../services/vueCustomerSvc';
  import ExpertiseIncluded from '../../../ExpertiseIncluded';
  import { paymentProfileClass } from '../../../../utilities/mrVueUtils';
  import BackButton from "../../BackButton";
  import SectionLink from "../../SectionLink";
  import Address from "../../../AddressBook/Address";
  import OrderItem from "./OrderItem/OrderItem";
  import FixedWidthTweakUpper from "../../../FixedWidthTweakUpper";

  export default {
    name: 'OrderDetails',

    components: {
      FixedWidthTweakUpper,
      OrderItem,
      Address,
      SectionLink,
      BackButton,
      ExpertiseIncluded
    },

    props: ['orderId'],

    data() {
      return {
        order: null
      }
    },

    methods: {
      paymentProfileClass
    },

    mounted() {
      vueCustomerSvc.getOrderSummary(this.orderId).then(res => {
        this.order = res.data;
      });
    }
  }
</script>

<style scoped lang='stylus'>
  .order-details
    .order-status-wrap
      .order-id
      .total
        display inline-block

      .order-id
        padding-right 10em

      .order-placed
        padding-bottom 0.5em

      .order-status
        display inline-block
        padding-right 1em

    .detail-wrap
      padding 1.5em 0

    .payment-method
      .method-icon
      .method
        display inline-block
        vertical-align top

      .method-icon
        padding 0 0.5em

    .order-summary
      .summary-wrap
        display inline-block
        vertical-align top

      .label
      .price
      .filler
        display inline-block
        vertical-align top

      .label
        min-width 10em
        max-width 10em
        text-align right
        margin-right 1em

    @media mq-mobile
      .order-summary
        border-top 1px solid #ccc

        .label
          min-width 12em
          max-width 12em

    @media mq-tablet
      .section
      .section-link
        padding 1.5em 10% !important

      .order-summary
        border-top 1px solid #ccc

    @media mq-desktop-md
      .section
      .section-link
        padding 1.5em 8% !important

      .payment-method
        padding 0 1em


    @media mq-desktop-plus
      .section
      .section-link
        padding 1.5em 10% !important

      .order-status-wrap
        .order-id
          padding-right 20em

      .payment-method
        padding 0 1em

</style>
